import {
  COLOR_CX_CHEAPER,
  COLOR_DRIVER_APP_CHEAPER,
  COLOR_PRICE_LEVEL,
} from 'components/reports/Metrics/constants/DriverAppFulfilment'

export const formatPercentage = (value: number) => `${value.toLocaleString()}%`

export const formatCount = (value: number) => value.toLocaleString()

export const colorOf = (label: string) => {
  if (label.endsWith('to 0%') || label.endsWith('to £0')) {
    return COLOR_PRICE_LEVEL
  }

  return label.startsWith('<') || label.startsWith('-')
    ? COLOR_CX_CHEAPER
    : COLOR_DRIVER_APP_CHEAPER
}
